import { z } from 'zod';

export const NOTE_MAX = 2000;

export const noteSchema = z.object({
  text: z
    .string()
    .trim()
    .min(1, { error: 'applications:validation.noteRequired' })
    .max(NOTE_MAX, { error: 'applications:validation.noteMax' }),
});

export type NoteValues = z.infer<typeof noteSchema>;
